import React from 'react';
import LegendComponent from '@atlassian/jira-aais-timeline-legend/src/ui/legend/index.tsx';
import IssueTypesLegend from './issue-types-legend/index.tsx';

const Legend = () => (
	<LegendComponent appearance="full" placement="bottom-end">
		<IssueTypesLegend />
	</LegendComponent>
);

export default Legend;
